$(document).on('facetwp-loaded', () => {
	var queryString = FWP.buildQueryString();
	if (queryString) {
		$('.vacancy-overview .filter-current').css('display', 'flex');
	} else {
		$('.vacancy-overview .filter-current').hide();
	}
});


document.addEventListener('DOMContentLoaded', () => {
	const filterToggles = document.querySelectorAll('.filter-toggle');
	if (filterToggles) {
		filterToggles.forEach((filterTitle) => {
			filterTitle.addEventListener('click', (e) => {
				filterTitle.closest('.filter-accordion').querySelector('.filter-accordion-content').classList.toggle('open');
			});
		});

		const body = document.body;
		const toggleButton = document.querySelectorAll('.offcanvas-toggler');
	
	
		toggleButton.forEach((button) => {
			const offCanvas = document.querySelector('[data-toggler="' + button.dataset.toggle + '"]');
	
			// Remove inline display: none to prevent offcanvas showing up on page load
			offCanvas.removeAttribute('style');
	
			button.addEventListener('click', () => {	
				offCanvas.classList.toggle('closed');
				offCanvas.classList.toggle('opened');
				button.classList.toggle('toggle-open');
				body.classList.toggle('offcanvas-open');
			});
		});
	}
});